import { useQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import { getSources, sourcesKey, type FreshnessMeta } from "./api";
import { SourceDetail } from "./SourceDetail";
import { SourcesTab, useOpenSource } from "./SourcesTab";

/**
 * The freshness bridge (native-module contract step 2). Reads `/sources` under
 * the Sources tab's own key, so the shell's freshness line and the tab are one
 * cache entry. When health is unreadable the API sends `data_as_of: null`, and
 * the shell says "we can't confirm this data's date" (I-6).
 */
export function useKpiDataIntegrityMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const head = useQuery({ queryKey: sourcesKey, queryFn: getSources, enabled });
  return enabled ? head.data?.meta : undefined;
}

/**
 * KPI v4 C10 Data Integrity, R1 thin: Sources and its Source detail drill-in.
 * `decision` is not read here: the shell has already wrapped this in
 * `PermissionGate` (I-7), and the API checks again (seam S5).
 */
export function KpiDataIntegrityModule({
  activeTabKey,
}: {
  decision: "edit" | "view" | "none";
  activeTabKey: string | null;
  areaName: string;
  ownerName?: string | null;
}) {
  const search = useSearch({ strict: false }) as { source?: string };
  const open = useOpenSource();

  if (activeTabKey === "overlap_audit") {
    return (
      <p className="text-sm text-ks-ink">
        The overlap audit arrives in a later release. Until then, the overlap report lives with the registry.
      </p>
    );
  }
  if (search.source) return <SourceDetail id={String(search.source)} onBack={() => open(null)} />;
  return <SourcesTab onOpen={(id) => open(id)} />;
}
